import { EnvironmentVariable } from './app-settings'

export class ConfigSettings {
  public readonly REACT_APP_BASENAME_APP: string
  public readonly REACT_APP_GOOGLE_ANALYTICS: string
  constructor(envVariables: EnvironmentVariable) {
    this.REACT_APP_BASENAME_APP = envVariables.REACT_APP_BASENAME_APP as string
    this.REACT_APP_GOOGLE_ANALYTICS = envVariables.REACT_APP_GOOGLE_ANALYTICS as string
  }
}
